import {ROLE_SUPERADMIN} from '../../constants/roles';
import { createHasSessionAccessSelector } from '../session';

export const selectCanAccessClients = createHasSessionAccessSelector([ROLE_SUPERADMIN]);